import React, { useEffect, useState } from 'react';

import Notifications from '../../components/notifications/Notifications';
import useBlocRef from '../../utils/useBlocRef.hook';

export default () => {
  const [notifications, setNotifications] = useState([]);
  const [totalNotifications, setTotalNotifications] = useState(0);

  const blocRef = useBlocRef('notificationsBloc');

  const handleLoadMoreClick = async () => {
    await blocRef.current.updateSearchCriteria({ lastId: notifications[notifications.length - 1].id });
  };

  const readNotification = async (id) => {
    await blocRef.current.readNotification(id);
  };

  const readAllNotification = async () => {
    await blocRef.current.readAllNotification();
  };

  useEffect(() => {
    const notificationsSub = blocRef.current.notifications$.subscribe(setNotifications);
    const totalSub = blocRef.current.total$.subscribe(setTotalNotifications);
    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      blocRef.current.dispose();
      notificationsSub.unsubscribe();
      totalSub.unsubscribe();
    };
  }, [blocRef]);

  return (
    <Notifications
      notifications={notifications}
      totalNotifications={totalNotifications}
      handleLoadMoreClick={handleLoadMoreClick}
      readNotification={readNotification}
      readAllNotification={readAllNotification}
    />
  );
};
